interface MedicationIconProps {
  color?: string;
}
export const MedicationIcon = ({ color }: MedicationIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path d="M14.3337 2.33333C13.467 1.46667 12.267 1 11.067 1C9.86704 1 8.66704 1.46667 7.80037 2.33333L3.06704 7.06667C1.26704 8.86667 1.26704 11.8667 3.06704 13.6667C3.93371 14.5333 5.13371 15 6.33371 15C7.53371 15 8.73371 14.5333 9.60037 13.6667L14.3337 8.93333C16.1337 7.13333 16.1337 4.13333 14.3337 2.33333ZM8.66704 12.7333C8.06704 13.3333 7.20037 13.7333 6.33371 13.7333C5.46704 13.7333 4.60037 13.3333 3.93371 12.7333C2.66704 11.4 2.66704 9.26667 3.93371 8L5.80037 6.13333L10.5337 10.8667L8.66704 12.7333Z" fill={color ?? '#000'}/>
  </svg>
);
